/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { IOS_SAFARI_ONLY, RECORDING_STATUS } from '../../constants/constants';
import RecorderHeader from './recorder-header/recorder-header.component';
import RecorderFooter from './recorder-footer/recorder-footer.component';
import RecorderContent from './recorder-content/recorder-content.component';
import './recorder.style.css';
import {
  isiOSMobileButNotSafari
} from '../../common/helpers/common.helpers';
import routes from '../../routes';
/**
 * Class representing the recorder component.
 * @extends Component
 * */
@inject('commonStore', 'filesStore', 'recorderStore')
@observer
class Recorder extends Component {

  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    commonStore: PropTypes.shape({
      openConfirmation: PropTypes.func,
    }),
    filesStore: PropTypes.shape({
      createMessage: PropTypes.func,
    }),
    recorderStore: PropTypes.shape({
      status: PropTypes.string,
      setStatus: PropTypes.func,
    }),

  };

  static defaultProps = {
    commonStore: {
      openConfirmation: () => {},
    },
    filesStore: {
      createMessage: () => {},
    },
    recorderStore: {
      status: RECORDING_STATUS.WAITING,
      setStatus: () => {},
    },
  };

  /**
   * Displays alert is user tries to record on mobile iOS from other browser than Safari.
   * */
  componentDidMount() {
    const {
      history: {
        push,
      }
    } = this.props;
    if (isiOSMobileButNotSafari(navigator, window)) {
      // eslint-disable-next-line
      alert(IOS_SAFARI_ONLY);
      push(routes.dashboard);
    }
  }

  render() {
    const {
      history: {
        push,
      },
      commonStore: {
        openConfirmation
      },
      filesStore: {
        createMessage
      },
      recorderStore: {
        clearTimer,
        parseTimer,
        pauseAudio,
        playAudio,
        resetAudio,
        recordBlob,
        setAudio,
        setStatus,
        startTimer,
        status,
        updateProgress,
        width,
      }
    } = this.props;

    return (
      <div className="recorder container">
        <RecorderHeader status={status} />
        <RecorderContent
          clearTimer={clearTimer}
          parseTimer={parseTimer}
          pauseAudio={pauseAudio}
          playAudio={playAudio}
          recordBlob={recordBlob}
          resetAudio={resetAudio}
          setAudio={setAudio}
          setStatus={setStatus}
          startTimer={startTimer}
          status={status}
          updateProgress={updateProgress}
          width={width}
        />
        <RecorderFooter
          createMessage={createMessage}
          openConfirmation={openConfirmation}
          push={push}
          recordBlob={recordBlob}
          setStatus={setStatus}
          startTimer={startTimer}
          status={status}
        />
      </div>
    );
  }
}

export default Recorder;



// WEBPACK FOOTER //
// ./src/messages/recorder/recorder.component.js